import update from './update'
import get from './get'
import set from './set'

export default {
  ...update,
  ...get,
  ...set
}
